module.exports = __webpack_public_path__ + "static/media/madTifBrianCal.d6f6de38.png";